import { QueryClient, useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { addLanguage, getLanguageList, getOrgStructureTree, UpdateCAVOrgStructureTree, updateLanguage } from "./SettingRepo"
import { showToast } from "../../../utils/toastUtils"

interface ParmaIntrface{
    search:string
}


export const useGetLanguageList = ({enable=false,params}:{enable:boolean,params:ParmaIntrface})=>{
    return useQuery({
        queryKey:['GET_LANGUAGE_LIST',params],
        queryFn:()=>getLanguageList(params),
        retry:false,
        enabled:enable,
    })
}

export const useAddLanguage = ()=>{
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn:(req:any)=>addLanguage(req),
        onSuccess:()=>{
            showToast.success('Langaiuge adde Successfully');
            queryClient.invalidateQueries({queryKey:['GET_LANGUAGE_LIST']})
        },
        onError:(error:any)=>{
            showToast.error('Failed to add Language');
            console.log(`Failed to add language ${error}`);
        }
    })
}

export const useUpdateLanguage=()=>{
   const queryClient = useQueryClient();
   return useMutation({
    mutationFn:({ReqBody,id}:{ReqBody:any,id:number| null})=>updateLanguage(ReqBody,id),
    onSuccess:()=>{
        showToast.success('Update Successfully');
        queryClient.invalidateQueries({queryKey:['GET_LANGUAGE_LIST']})
    },
    onError:(error:any)=>{  
    showToast.error('Failed to Upate');
    console.log(`Failed to Update ${error.message}`);
    }
   })
}


export const useGetOrgStructureTree = ({enable=false,params}:{enable:boolean,params:Record<string,any>})=>{
    return useQuery({
        queryKey:['GET_ORG_STRUCTURE_TREE',params],
        queryFn:()=>getOrgStructureTree(params),
        retry:false,
        enabled:enable,
    })
}

export const useUPDATECAVOrgStructureTree = ({enable=false,id}:{enable:boolean,id:Record<string,any>})=>{
    return useQuery({
        queryKey:['GET_ORG_STRUCTURE_TREE',id],
        queryFn:()=>UpdateCAVOrgStructureTree(id),
        retry:false,
        enabled:enable,
    })
}